import React from 'react';
import { observer } from 'mobx-react-lite';
import { Button, Tooltip } from '@insurancemenu/imenu-components-lib';
import { dateFormatters } from '@insurancemenu/imenu-components-lib/dist/helpers';
import { DollarCircle, PeopleGroup } from '@insurancemenu/imenu-components-lib/dist/icons';
import { uwRights } from '@insurancemenu/imenu-components-lib/dist/utils/accessRights';
import ProposalInfoSection from 'components/common/proposal/ProposalInfoSection';
import { useAddQuotePageStore } from 'store/pages/quote/add-quote/pageStore';
import { useRootStore } from 'store/rootStore';
import { AlignmentTypes } from '@insurancemenu/imenu-components-lib/dist/types';
import { MainInfoPanelStyled } from './styles';

const ESTIMATED_COST_DISABLED_TOOLTIP = 'Add at least one plan to estimate the cost.';

const AddQuoteMainInfo: React.FC = observer(() => {
  const { cart, proposal, isMutableProposal, annualPremiumFormId, onOverrideRates, onEstimatedCost } =
    useAddQuotePageStore();
  const {
    userStore: { userRoles },
  } = useRootStore();

  const mainInfo = {
    'Effective Date': dateFormatters.normDateToShortAmericanDate(cart.lastUpdateBrowsingCriteria.effectiveDate),
    Location: `${cart.lastUpdateBrowsingCriteria.county}, ${cart.lastUpdateBrowsingCriteria.state} ${cart.lastUpdateBrowsingCriteria.zipCode}`,
    'Created On': proposal?.createdOn ? dateFormatters.normDateToShortAmericanDate(proposal.createdOn) : '',
    'Created By': proposal?.createdBy?.name || '',
    'Last modified': cart.lastUpdateTime ? dateFormatters.normDateToAmericanDateTime(cart.lastUpdateTime) : '',
  };

  function renderEstimatedCostButton(): React.ReactNode {
    if (!annualPremiumFormId) return null;

    if (cart.cartItems.length === 0) {
      return (
        <Tooltip label={ESTIMATED_COST_DISABLED_TOOLTIP} alignment={AlignmentTypes.BOTTOM_END}>
          <Button type="text" color="primary" leftIconProp={<PeopleGroup />} uppercase disabled>
            Estimate Cost
          </Button>
        </Tooltip>
      );
    }

    return (
      <Button type="text" color="primary" leftIconProp={<PeopleGroup />} uppercase onClick={onEstimatedCost}>
        Estimate Cost
      </Button>
    );
  }

  return (
    <MainInfoPanelStyled>
      <ProposalInfoSection
        title={proposal?.name || cart.cartName}
        mainInfo={mainInfo}
        actions={
          <>
            {isMutableProposal && uwRights(userRoles) && (
              <Button type="text" color="primary" leftIconProp={<DollarCircle />} uppercase onClick={onOverrideRates}>
                Override Rates
              </Button>
            )}
            {renderEstimatedCostButton()}
          </>
        }
      />
    </MainInfoPanelStyled>
  );
});

export default AddQuoteMainInfo;
